import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { AppHttpInterceptor } from './core/utils/app-http-interceptor';
import { AuthGuard } from './core/guards/auth.guard';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {provideNativeDateAdapter} from '@angular/material/core';
import {  ArcElement, BarController, BarElement, Colors, Legend, LineElement, PointElement } from 'chart.js';
registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes), 
    provideClientHydration(),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    provideAnimations(), // required animations providers
    provideToastr(), 
    { provide: LOCALE_ID, useValue: 'fr' },
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    provideNativeDateAdapter(),
    provideCharts(
      { registerables: [BarController, Legend, Colors,ArcElement,BarElement,PointElement,LineElement,ArcElement] },
      withDefaultRegisterables())
  ]
};
